/**
 * External Dependencies
 */
//import 'jquery';

import { themeCookie } from './functions/cookies.js';
import { themeMenu } from './functions/menu.js';
import { initAccordion } from './functions/accordion.js';
import { pageFilter } from './functions/page-filter.js';
import { galleryFader } from './functions/fader.js';

// Make life easier for later!!
const select = (e) => document.querySelector(e);
const selectAll = (e) => document.querySelectorAll(e);

document.addEventListener('DOMContentLoaded', () => {
  //galleryFader();
  //console.log('doc loaded');
});

galleryFader();

window.addEventListener('DOMContentLoaded', () => {

  themeCookie();

  themeMenu();

  pageFilter();

  initAccordion( selectAll('.site-menu__item--has-children') );

  // Header scroll
  const header        = select('.site-header');
  const button        = select('.site-header__cta .btn');
  const scrollUp      = 'scroll-up';
  const scrollDown    = 'scroll-down';
  let lastScroll      = 0;

  // https://webdesign.tutsplus.com/tutorials/how-to-hide-reveal-a-sticky-header-on-scroll-with-javascript--cms-33756
  window.addEventListener('scroll', () => {

    // Bail is no js
    if( select('html').classList.contains('no-js') || document.body.classList.contains('menu-open') ) {
      return;
    }

    const currentScroll = window.pageYOffset;

    if( currentScroll <= 50 ) {
      header.classList.remove(scrollUp);
      //button.classList.remove('btn--primary');
      //button.classList.add('btn--fade');
      return;
    }

    if( currentScroll > lastScroll && !header.classList.contains(scrollDown) ) {
      // down
      header.classList.remove(scrollUp);
      header.classList.add(scrollDown);
      //button.classList.add('btn--fade');
      //button.classList.remove('btn--primary');
    } else if( currentScroll < lastScroll && header.classList.contains(scrollDown) ) {
      // up
      header.classList.remove(scrollDown);
      header.classList.add(scrollUp);
      //button.classList.remove('btn--fade');
      //button.classList.add('btn--primary');
    }

    lastScroll = currentScroll;

  });

  // Show overflow els
  /*const docWidth = document.documentElement.offsetWidth;

  [].forEach.call(
    document.querySelectorAll('*'),
    function(el) {
      if (el.offsetWidth > docWidth) {
        console.log(el);
        el.classList.add('show-overflow');
      }
    }
  );*/

});
